<template>
  <div>
    <div class="bar_wrapper" :id="`bar_wrapper_${keyRandom}`" :style="{'--barWidth':`${barWidth}px`}">
      <div
        :id="`bar_${keyRandom}`"
        class="bar"
        :style="{
          backgroundColor: bgColor,
        }"
      >
        <div class="box" ref="swiperbox">
          <div class="swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in tabList"
                :class="{ on: tagIndex == index }"
                :style="{ backgroundColor: tagIndex == index ? (tabColor||buttonColor) : '#FFF', color: (tabColor||buttonColor)}"
                :key="index"
                @click="jumpToBlock(index, item)"
              >
              <span>
                {{ item.labelName }}
              </span>
                <em :style="`border-top-color: ${tabColor||buttonColor};`"></em>
                <!-- 小红点显示逻辑,0417本期不做，先放着 -->
                <!-- <span class="red-dot"></span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { throttle } from 'lodash';
export default {
  name: "TabBar",
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
    buttonColor: {
      type: String,
      default: "",
    },
    tabList:{
      type:Array,
      default:()=>[]
    },
  },
  data() {
    return {
      swiper: null,
      bgColor: "",
      stateHeight: 0,
      tagIndex: 0,
      keyRandom:Math.floor(100 + Math.random() * 900),
      throttledScroll: null
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    barTop() {
      return 44 + this.stateHeight - 1;
    },
    barHeight() {
      return 54 + this.barTop;
    },
    isForPC(){
      return this.commonStore.isForPC
    },
    barWidth(){
      let elWidth = document.getElementsByClassName("activity-container")[0].clientWidth;
      return elWidth >=1200 ? 1200:elWidth;
    },
    tabColor(){
      return this.componentConfig?.jobTabComponentDTO?.tabColor;
    }
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler() {
        this.slideReset();
      },
      immediate: false,
    },
  },
  async mounted() {
    if (this.$store.state.commonStore.searchPage) {
      this.stateHeight = "0px";
    } else {
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    this.stateHeight = parseInt(this.stateHeight);

    this.slideIni();
    this.$nextTick(()=>{
      this.throttledScroll = throttle(() => {
        this.handleScroll();
      }, 100); // 每1000ms最多执行一次
      window.addEventListener("scroll", this.throttledScroll);
    })
  },
  beforeDestroy() {
    try {
      window.removeEventListener("scroll", this.throttledScroll);
    } catch (e) {}
  },
  methods: {
    slideIni() {
      this.swiper = new Swiper(".swiper", {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 6,
      });
    },
    slideReset() {
      this.tagIndex = 0;
      this.swiper.destroy();
      this.$nextTick(() => {
        this.slideIni();
      });
    },
    handleScroll(){
      const vm = this; // 现在可以正确访问组件实例
      const bar_wrapper = document.getElementById(`bar_wrapper_${vm.keyRandom}`);
      const bar = document.getElementById(`bar_${vm.keyRandom}`);
      const rect = bar_wrapper?.getBoundingClientRect();
      const top = rect?.top;
      const scrollY = window.scrollY || window.pageYOffset;
      const element = document.getElementById(`multiColumnBox${vm.componentConfig.deWeightSort}`);
      if(!element){
        return false
      }
      // 获取元素的原始位置和高度
      const originalOffsetTop = element.offsetTop;
      const elementHeight = element.offsetHeight;
      if (top <= vm.barTop) {
        if(bar.style.position !== 'fixed'){
          vm.bgColor = vm.isForPC ? vm.pageConfig.backgroundColor:vm.pageConfig.hideColor;
          vm.moreTagBg = vm.pageConfig.hideColor;
          bar.style.position = "fixed";
          bar.style.top = vm.isForPC ? "0px":vm.barTop + "px";
          bar.style.zIndex = 10 + Number(vm.componentConfig.deWeightSort);
          bar.style.paddingBottom = '6px';
        }
      } else {
        if(bar.style.position === 'fixed'){
          vm.bgColor = "";
          vm.moreTagBg = vm.pageConfig.backgroundColor;
          bar.style.position = "relative";
          bar.style.top = "0";
          bar.style.zIndex = 0;
          bar.style.paddingBottom = '0px';
        }
      }
      if(scrollY >= originalOffsetTop + elementHeight - (vm.barTop + bar.offsetHeight)){
        if(bar.style.position === 'fixed'){
          vm.bgColor = "";
          vm.moreTagBg = vm.pageConfig.backgroundColor;
          bar.style.position = "relative";
          bar.style.top = "0";
          bar.style.zIndex = 0;
          bar.style.paddingBottom = '0px';
        }
      }
    },
    adjustSwiperIndex() {
      // 矫正swiper，确保tag可见
      const box = this.$refs.swiperbox;
      const slide = box.querySelectorAll(".swiper-slide")[this.tagIndex];
      // 解决dom不存在时报错
      if (slide && slide.getBoundingClientRect()) {
        const left =
          slide.getBoundingClientRect().left - box.getBoundingClientRect().left;
        if (left >= box.offsetWidth / 2 || left <= box.offsetWidth / 4) {
          const index = this.tagIndex > 1 ? this.tagIndex - 2 : 0;

          this.swiper.slideTo(index, 200, false);
        }
      }
    },
    scrollWait() {
      // 对scrollTo方法的“回调”处理
      if ("onscrollend" in window) {
        const wait = () => {
          window.removeEventListener("scrollend", wait);
        };

        window.addEventListener("scrollend", wait);
      }
    },
    jumpToBlock(index,cui) {
      // 点击tag后跳转
      this.tagIndex = index;
      this.$emit('handleTabChange',cui)
      this.adjustSwiperIndex();
      this.scrollWait();
    },
  },
};
</script>
  
  <style scoped lang="less">
.bar_wrapper {
  // height: 30px;
  margin-bottom: -4px;
  .adapt_pc_widescreen & {
    // height: 43px;
    margin-bottom: -4px;
  }
}

.bar {
  position: relative;
  width: var(--barWidth);
  margin: 0 auto;
  // height: 50px;
  padding:6px 0 0px 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
    .adapt_pc_widescreen & {
      padding:15px 0 0px 0;
    }

  .box {
    position: relative;
    height: 28px;
    overflow: hidden;
    z-index: 1;
    .adapt_pc_widescreen & {
      height: 43px;
    }
  }

  .more {
    display: none;
    position: absolute;
    width: 25px;
    height: 40px;
    right: 0;
    top: 8px;
    z-index: 2;

    svg {
      position: relative;
      top: 6px;
    }

    span {
      position: absolute;
      width: 23px;
      height: 40px;
      top: 0;
      left: -20px;
    }
  }

  .list {
    display: none;
    position: absolute;
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    color: #222;
    top: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 1000;

    &.show {
      display: block;
    }

    .in {
      background-color: #fff;
      border-radius: 0 0 20px 20px;
    }

    .title {
      line-height: 17px;
      padding: 12px 16px 16px;
    }

    ul {
      padding: 0 10px 4px;

      li {
        float: left;
        width: 33%;
        padding: 0 6px 12px;
        box-sizing: border-box;

        span {
          display: block;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          background: #f2f4f7;
          border-radius: 21px;

          &.on {
            color: #fff;
            background: linear-gradient(180deg, #ffb245 1%, #ff4e0e 99%);
          }
        }
      }

      li:nth-of-type(3n-1) {
        width: 34%;
      }

      &:after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }

  &.has_more {
    .box {
      padding-right: 50px;
    }

    .more {
      display: flex;
    }
  }
}

.pc .bar {
  // width: 1200px;
  // margin: 0 auto;
}

.swiper {
  .swiper-slide {
    display: inline-block;
    position: relative;
    width: auto;
    line-height: 23px;
    height: 23px;
    font-size: 12px;
    text-align: center;
    padding: 0 15px;
    border-radius: 16px;
    background-color: #fff;
    font-family: PingFang SC;
    min-width: 36px;
    margin-right: 8px !important;
    .adapt_pc_widescreen & {
      font-size: 19px;
      line-height: 36px;
      height: 36px;
      font-weight: 500;
      border-radius: 46px;
    }
    span {
        height: 23px;
        line-height: 23px;
    }

    &:first-child {
      margin-left: 12px;
    }

    &.on {
      position: relative;
      color: #fff !important;
      span{
        font-weight: 550;
      }
      em {
        display: block;
        position: absolute;
        content: "";
        left: 53%;
        bottom: -4px;
        width: 0;
        height: 0;
        margin-left: -8px;
        border-style: solid;
        border-width: 6px;
        border-color: transparent;
        border-bottom: none;
      }
    }

    em {
      display: none;
    }
    .red-dot {
      position: absolute;
      right: 0px;
      top: 0;
      width: 8px;
      height: 8px;
      background: linear-gradient(0deg, #FF3838, #FF3838), #FF6439;
      border-radius: 8px;
    }

  }
}
</style>
  